
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/old-index",
      function () {
        return require("private-next-pages/old-index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/old-index"])
      });
    }
  